import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { formatDate } from '../../Helpers/dateHelpers';
import { getFullFileUrl } from '../../Helpers/UrlHelpers';
import {
    faUser,
    faEllipsisH,
    faTrash,
    faEdit,
    faPaperPlane
} from '@fortawesome/free-solid-svg-icons';
import ApiServices from '../Services/ApiServices';
import platformLogo from '../../assets/images/new_log_design.svg';

const BlogCommentItem = ({ comment, onLike, onDelete, onEdit, onReplyAdded, currentUser, blogId, userId, postOwnerId }) => {
    const [showOptions, setShowOptions] = useState(false);
    const [isEditing, setIsEditing] = useState(false);
    const [editedContent, setEditedContent] = useState(comment.content);

    // Check if this is a platform comment
    const isPlatformComment = comment.user_name === 'منصة امتحاني';

    // Reply State
    const [showReplyInput, setShowReplyInput] = useState(false);
    const [replyContent, setReplyContent] = useState('');
    const [isSubmittingReply, setIsSubmittingReply] = useState(false);

    // Format time relatively (e.g. "2d")
    const getRelativeTime = (dateString) => {
        if (!dateString) return "";
        const date = new Date(dateString);
        const now = new Date();
        const diff = Math.floor((now - date) / 1000); // seconds

        if (diff < 60) return "الآن";
        if (diff < 3600) return `${Math.floor(diff / 60)} د`;
        if (diff < 86400) return `${Math.floor(diff / 3600)} س`;
        if (diff < 604800) return `${Math.floor(diff / 86400)} ي`;
        return `${Math.floor(diff / 604800)} أ`;
    };

    const handleEditSubmit = (e) => {
        e.preventDefault();
        onEdit(comment.id, editedContent);
        setIsEditing(false);
    };

    const handleReplySubmit = async (e) => {
        e.preventDefault();
        if (!replyContent.trim()) return;

        try {
            setIsSubmittingReply(true);
            const replyData = {
                content: replyContent,
                parent_id: comment.id,
                blog_id: parseInt(blogId),
                user_id: parseInt(userId)
            };

            const response = await ApiServices.post(`Blogs/Comments/Create`, replyData);
            if (response.check) {
                setReplyContent('');
                setShowReplyInput(false);
                if (onReplyAdded) onReplyAdded();
            }
        } catch (error) {
        } finally {
            setIsSubmittingReply(false);
        }
    };

    return (
        <div className={`linkedin-comment-item ${showOptions ? 'is-active' : ''}`}>
            <div className="comment-row">

                {/* Avatar */}
                <div className="comment-avatar">
                    {isPlatformComment ? (
                        <img
                            src={platformLogo}
                            alt="منصة امتحاني"
                            className="platform-comment-logo"
                        />
                    ) : comment.image ? (
                        <img
                            src={getFullFileUrl(comment.image)}
                            alt={comment.user_name || 'مستخدم'}
                            onError={(e) => {
                                e.target.style.display = 'none';
                                e.target.nextSibling.style.display = 'flex';
                            }}
                        />
                    ) : (
                        <div className="default-avatar-circle">
                            <FontAwesomeIcon icon={faUser} />
                        </div>
                    )}
                    {!isPlatformComment && (
                        <div className="default-avatar-circle" style={{ display: comment.image ? 'none' : 'flex' }}>
                            <FontAwesomeIcon icon={faUser} />
                        </div>
                    )}
                </div>

                {/* Content Column */}
                <div className="comment-content-col">

                    {/* Bubble */}
                    <div className="comment-bubble">
                        <div className="bubble-header">
                            <span className="comment-author-name">{comment.user_name || 'مستخدم'}</span>
                            <span className="comment-time">{getRelativeTime(comment.date)}</span>
                        </div>
                        {/* <div className="author-headline">Member at EMt7any</div> */}

                        {isEditing ? (
                            <form onSubmit={handleEditSubmit} className="edit-form">
                                <input
                                    className="edit-input"
                                    value={editedContent}
                                    onChange={(e) => setEditedContent(e.target.value)}
                                    autoFocus
                                />
                                <div className="edit-actions">
                                    <button type="button" onClick={() => setIsEditing(false)}>إلغاء</button>
                                    <button type="submit" disabled={!editedContent.trim()}>حفظ</button>
                                </div>
                            </form>
                        ) : (
                            <div className="comment-text">{comment.content}</div>
                        )}
                    </div>

                    {/* Action Footer */}
                    <div className="comment-actions-footer">
                        {userId && (
                            <>
                                <button
                                    className={`footer-action-btn ${comment.likes > 0 ? 'liked' : ''}`}
                                    onClick={() => onLike(comment.id)}
                                >
                                    إعجاب {comment.likes > 0 && `(${comment.likes})`}
                                </button>
                                <span className="dot">•</span>
                                <button
                                    className="footer-action-btn"
                                    onClick={() => setShowReplyInput(!showReplyInput)}
                                >
                                    رد
                                </button>
                            </>
                        )}

                        {/* Options: Edit (Comment Owner Only), Delete (Comment Owner OR Post Owner) */}
                        {userId && (
                            comment.user_id?.toString() === userId?.toString() ||
                            comment.userId?.toString() === userId?.toString() ||
                            postOwnerId?.toString() === userId?.toString()
                        ) && (
                                <>
                                    <span className="dot">•</span>
                                    <div className={`options-wrapper ${showOptions ? 'active' : ''}`}>
                                        <button
                                            className="footer-action-btn options-trigger"
                                            onClick={() => setShowOptions(!showOptions)}
                                        >
                                            <FontAwesomeIcon icon={faEllipsisH} />
                                        </button>

                                        {showOptions && (
                                            <>
                                                <div className="options-overlay" onClick={() => setShowOptions(false)} />
                                                <div className="options-popup">
                                                    {(comment.user_id?.toString() === userId?.toString() || comment.userId?.toString() === userId?.toString()) && (
                                                        <button onClick={() => { setIsEditing(true); setShowOptions(false); }}>
                                                            <FontAwesomeIcon icon={faEdit} /> تعديل
                                                        </button>
                                                    )}
                                                    <button onClick={() => { onDelete(comment.id); setShowOptions(false); }}>
                                                        <FontAwesomeIcon icon={faTrash} /> حذف
                                                    </button>
                                                </div>
                                            </>
                                        )}
                                    </div>
                                </>
                            )}
                    </div>

                    {/* Reply Input */}
                    {showReplyInput && (
                        <form onSubmit={handleReplySubmit} className="reply-input-form">
                            <div className="reply-input-wrapper">
                                <input
                                    type="text"
                                    placeholder="اكتب ردك..."
                                    value={replyContent}
                                    onChange={(e) => setReplyContent(e.target.value)}
                                    disabled={isSubmittingReply}
                                />
                                <button type="submit" disabled={!replyContent.trim() || isSubmittingReply}>
                                    <FontAwesomeIcon icon={faPaperPlane} />
                                </button>
                            </div>
                        </form>
                    )}

                    {/* Recursive Replies */}
                    {comment.replies && comment.replies.length > 0 && (
                        <div className="nested-replies">
                            {comment.replies.map(reply => (
                                <BlogCommentItem
                                    key={reply.id}
                                    comment={reply}
                                    onLike={onLike}
                                    onDelete={onDelete}
                                    onEdit={onEdit}
                                    onReplyAdded={onReplyAdded}
                                    currentUser={currentUser}
                                    blogId={blogId}
                                    userId={userId}
                                    postOwnerId={postOwnerId}
                                />
                            ))}
                        </div>
                    )}

                </div>
            </div>

            <style jsx>{`
                .linkedin-comment-item {
                    margin-bottom: 8px;
                    font-size: 14px;
                    direction: rtl;
                    position: relative;
                }

                .linkedin-comment-item.is-active {
                    z-index: 999;
                }

                .comment-row {
                    display: flex;
                    gap: 8px;
                }

                .comment-avatar {
                    width: 32px;
                    height: 32px;
                    flex-shrink: 0;
                }

                .comment-avatar img {
                    width: 32px;
                    height: 32px;
                    border-radius: 50%;
                    object-fit: cover;
                }

                .platform-comment-logo {
                    object-fit: contain !important;
                    padding: 2px;
                    background: white;
                }

                .default-avatar-circle {
                    width: 32px;
                    height: 32px;
                    background: #ccc;
                    border-radius: 50%;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    color: white;
                    font-size: 12px;
                }

                .comment-content-col {
                    flex: 1;
                    display: flex;
                    flex-direction: column;
                    align-items: flex-start;
                }

                .comment-bubble {
                    background-color: #f2f2f2;
                    padding: 8px 12px;
                    border-radius: 0 12px 12px 12px; /* RTL curve: TopRight is sharp (0) if we want, or make all rounded. LinkedIn does all rounded usually */
                    border-radius: 12px;
                    display: inline-block;
                    max-width: 100%;
                    position: relative;
                }

                /* Bubble Header */
                .bubble-header {
                    display: flex;
                    justify-content: space-between;
                    align-items: baseline;
                    margin-bottom: 4px;
                    gap: 8px;
                }

                .comment-author-name {
                    font-weight: 600;
                    color: #000;
                    font-size: 14px;
                }

                .comment-time {
                    font-size: 11px;
                    color: #666;
                }

                .author-headline {
                    font-size: 11px;
                    color: #666;
                    margin-bottom: 4px;
                    display: block;
                }

                .comment-text {
                    color: #191919;
                    font-size: 14px;
                    line-height: 1.4;
                    word-wrap: break-word;
                }

                /* Edit Form inside bubble */
                .edit-form {
                    width: 100%;
                }
                .edit-input {
                    width: 100%;
                    border: 1px solid #0a66c2;
                    border-radius: 4px;
                    padding: 4px;
                    margin-bottom: 4px;
                }
                .edit-actions {
                    display: flex;
                    gap: 8px;
                    font-size: 12px;
                }
                .edit-actions button {
                    background: none;
                    border: none;
                    cursor: pointer;
                    color: #0a66c2;
                    font-weight: 600;
                }

                /* Action Footer */
                .comment-actions-footer {
                    display: flex;
                    align-items: center;
                    gap: 4px;
                    margin-top: 4px;
                    margin-bottom: 8px;
                    padding-right: 4px; /* Align slightly */
                }

                .footer-action-btn {
                    background: none;
                    border: none;
                    font-size: 12px;
                    color: #666;
                    font-weight: 600;
                    cursor: pointer;
                    padding: 2px 4px;
                    border-radius: 4px;
                    font-family : 'cairo', sans-serif;
                }

                .footer-action-btn:hover {
                    background-color: #f2f2f2;
                    color: #000;
                }

                .footer-action-btn.liked {
                    color: #0a66c2;
                    font-family : 'cairo', sans-serif;
                }

                .dot {
                    font-size: 8px;
                    color: #666;
                }

                /* Options Popup */
                .options-wrapper {
                    position: relative;
                }
                .options-wrapper.active {
                    z-index: 1000;
                }
                .options-overlay {
                    position: fixed;
                    top: 0;
                    left: 0;
                    right: 0;
                    bottom: 0;
                    z-index: 999;
                    background: transparent;
                }
                .options-popup {
                    position: absolute;
                    top: 100%;
                    right: 0;
                    background: white;
                    box-shadow: 0 4px 12px rgba(0,0,0,0.15);
                    border-radius: 8px;
                    padding: 4px 0;
                    z-index: 1001;
                    min-width: 120px;
                    border: 1px solid #e0e0e0;
                }
                .options-popup button {
                    display: block;
                    width: 100%;
                    text-align: right;
                    background: none;
                    border: none;
                    padding: 8px 12px;
                    font-size: 13px;
                    color: #666;
                    cursor: pointer;
                }
                .options-popup button:hover {
                    background-color: #f2f2f2;
                }

                /* Reply Input */
                .reply-input-form {
                    margin-bottom: 12px;
                    width: 100%;
                }
                .reply-input-wrapper {
                    display: flex;
                    align-items: center;
                    border: 1px solid #ccc;
                    border-radius: 16px;
                    padding: 4px 8px;
                    background: white;
                }
                .reply-input-wrapper input {
                    flex: 1;
                    border: none;
                    outline: none;
                    font-size: 13px;
                }
                .reply-input-wrapper button {
                    background: none;
                    border: none;
                    color: #0a66c2;
                    cursor: pointer;
                }

                /* Nested Replies */
                .nested-replies {
                    width: 100%;
                    margin-top: 4px;
                    padding-right: 12px; /* Indent */
                    border-right: 2px solid #f2f2f2; /* Optional: vertical line */
                }

            `}</style>
        </div>
    );
};

export default BlogCommentItem;